import React, { useEffect } from "react";
import "./style/basketTableStyle.scss";
import { BasketItem } from "../../models/BasketItem";
import BasketListItem from "./BasketItem/BasketItem";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import useBasketManager from "./hooks/useBasketManager";
import { TicketAccess } from "../../models/TicketAccess";
import BasketListItemMobile from "./BasketItem/BasketItemMobile";
import useBasketSocks from "./hooks/Socks/useBasketSocks";
import useFacility from "../../../utils/hooks/useFacility";
import useKortosfera from "./hooks/Socks/useKortosfera";
import LoadingSpinner from "../../../features/Loading/LoadingSpinner";
import BasketExtras from "./BasketExtras";
import { useTranslation } from "react-i18next";
import useSrem from "./hooks/Socks/useSrem";
import usePCN from "./hooks/Socks/usePCN";
import EAAlert from "../shared/EAAlert";

interface IProps {
  handleDelete: (index: number) => void;
  handleGetBasket: Function;
  basket: BasketItem[];
  hideExerciseInfo?: boolean;
}

const BasketTable: React.FC<IProps> = ({ handleDelete, handleGetBasket, basket, hideExerciseInfo }: IProps) => {
  const isDesktop = useDesktopSize();
  const facilityIds = useFacility();
  const { t } = useTranslation();
  const { checkAdditionalBasket, handleAddBasket, isLoading, addError } = useBasketManager();
  const { addKortosferaGuide } = useKortosfera();
  const { addSocks, loading } = useBasketSocks();
  const { addPCNGuide } = usePCN();
  useSrem();

  useEffect(() => {
    checkAdditionalBasket(basket);
    setTimeout(() => {
      checkAfterDelete();
    }, 200);
    //eslint-disable-next-line
  }, []);

  const checkAfterDelete = async () => {
    if (facilityIds === "1200") {
      addSocks(basket);
    }
    if (facilityIds === "1204") {
      addSocks(basket);
    }

    if (facilityIds === "1227") {
      addSocks(basket);
    }
    if (facilityIds === "1228") {
      addKortosferaGuide(basket);
    }
    if (facilityIds === "1220") {
      addPCNGuide(basket);
    }
    // if (facilityIds === "1212") {
    //   addRocket(basket);
    //   addTenisRocket(basket);
    // }
    // if (facilityIds === "1224") {
    //   addFreeTicket(basket);
    // }
  };

  const handleBasketChanges = (
    assortIds: string,
    assortName: string,
    price: number,
    ticketAccess: TicketAccess | any,
    validFrom: string | null,
    qnt: number | 1
  ) => {
    handleAddBasket(assortIds, assortName, price, ticketAccess, validFrom, qnt);
  };

  return (
    <>
      {addError && <EAAlert type="error" message={addError} />}
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          {" "}
          {isDesktop ? (
            <>
              <div className={`basket-table`}>
                <div className={"basket-header flex-between-center"}>
                  <div></div>
                  <div></div>
                  <div>{t("cena")}</div>
                  <div>{t("ilosc")}</div>
                  <div>{t("wartosc")}</div>
                  <div></div>
                </div>
                {basket.map((item, index) => (
                  <div key={index} className={"basket-body"}>
                    <BasketListItem
                      item={item}
                      index={index}
                      refreshBasket={checkAfterDelete}
                      onRemoveBasket={handleDelete}
                      handleAddBasket={handleBasketChanges}
                      handleGetBasket={handleGetBasket}
                      isLoading={isLoading}
                      hideExerciseInfo={hideExerciseInfo}
                    />
                  </div>
                ))}
                {/* Extras inline below items */}
                {basket.length > 0 && (
                  <div className={"basket-body"}>
                    <BasketExtras handleGetBasket={handleGetBasket} />
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className="basket-table-mobile">
              {basket.map((item, index) => (
                <div key={index} className={"basket-body"}>
                  <BasketListItemMobile
                    item={item}
                    index={index}
                    refreshBasket={checkAfterDelete}
                    onRemoveBasket={handleDelete}
                    handleAddBasket={handleBasketChanges}
                    handleGetBasket={handleGetBasket}
                    isLoading={isLoading}
                    hideExerciseInfo={hideExerciseInfo}
                  />
                </div>
              ))}
              {basket.length > 0 && (
                <div className={"basket-body"}>
                  <BasketExtras handleGetBasket={handleGetBasket} />
                </div>
              )}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default BasketTable;
